import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../context/auth";
import moment from "moment";
import { Link } from "react-router-dom";
import { VerConfiguracion } from "./configuracionGeneral/modalConfigGeneral";
import { CambioClave } from "./modalCambiarClave";
import imgEscudo from "../imagenes/escudo.png";
import { Dimmer } from "./spinner";
import comercioService from "./hacienda/actividadEconomica/service/comercio.service";
import { formatMoneda } from "../util/varios";

function Header() {
  let op = require("../../src/modulos/datos");
  const factorCambio = JSON.parse(localStorage.getItem('factorCambio'))

  const { user, logout } = useContext(AuthContext);
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema"),
  );
  const efiscaldes = localStorage.getItem("efiscaldes");
  const [usuario, setUsuario] = useState("");
  const [nomOrg, setNomOrg] = useState("");
  const [mostrar, setMostrar] = useState(false);
  const [mostrarClave, setMostrarClave] = useState(false);
  const [activate, setActivate] = useState(false);

  const [escudoError, setEscudoError] = useState(false);
  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
    setFechaSistema(obj.fechasistema);

    if (obj != null) {
      setUsuario(obj.login);
      setNomOrg(obj.nombreorg);
    } else {
      setUsuario("");
      setNomOrg("");
    }
  }, []);

  const header = user && (
    <nav
      className="navbar navbar-expand navbar-primary navbar-light azulGradiant"
      style={{ marginLeft: 0, color: "#fff", height: "100%" }}
    >
      <ul className="navbar-nav py-0 ml-4">
        <li
          className="nav-item py-0 rounded"
          style={{
            position: "relative",
            width: "80px",
            height: "60px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={op.imagenes + "/imagen?img=" + op.logoEscudo}
            // src={imgEscudo}
            onError={() => setEscudoError(true)}
            style={{
              position: "absolute",
              maxHeight: "220px",
              maxWidth: "150px",
              zIndex: 1,
              top: "-10px",
              filter: "drop-shadow(7px -2px 4px rgba(0, 0, 0, 0.8))",
              left: "-30px",
              visibility: escudoError ? "collapse" : "visible",
            }}
          />
          {/* <img
            src={op.imagenes + "/imagen?img=" + op.logologin}
            style={{
              position: "relative",
              zIndex: 2, // Va adelante
              height: "60px",
              width: "60px",
              borderRadius: "8px",
              boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
              transition: "all 0.3s ease",
            }}
            alt="Logo"
          /> */}
        </li>
      </ul>
      <ul className="navbar-nav mx-auto">
        <div className="py-3 titulofiscal fw-bolder pre">
          {nomOrg + "(" + efiscaldes + ")"}
        </div>
      </ul>
      <ul className="navbar-nav ml-auto">
        <div className="py-3 fw-bold text-uppercase">
          Valor Euro €: {formatMoneda(
            factorCambio?.valor?.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          )}
        </div>
      </ul>
      <ul className="navbar-nav ml-auto">
        <li className="nav-item">
          <a
            className="nav-link titulofiscal"
            style={{ color: "#ffffff" }}
            onClick={(event) => {
              event.preventDefault();
            }}
            href="#"
          >
            <i className="far fa-calendar-alt">
              {" "}
              {moment.utc(fechaSistema).format("DD/MM/YYYY")}
            </i>
          </a>
        </li>
        <li className="nav-item dropstart">
          <div className="btn-group">
            <a
              className="dropdown-toggle nav-link"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              style={{ color: "#ffffff" }}
              onClick={(event) => {
                event.preventDefault();
              }}
              href="#"
            >
              <i className="fas fa-user-tie"> {usuario}</i>
            </a>
            <ul className="dropdown-menu">
              <li>
                <a
                  className="dropdown-item fw-bold bg-light"
                  type="button"
                  onClick={() => {
                    setMostrar(true);
                  }}
                >
                  Configuración General
                </a>
              </li>
              <li>
                <a
                  className="dropdown-item fw-bold bg-light"
                  type="button"
                  onClick={() => {
                    setMostrarClave(true);
                  }}
                >
                  Cambiar Contraseña
                </a>
              </li>
            </ul>
          </div>
        </li>
        <Link onClick={op.nombre === "aguablancahac" ? logout : null} className="nav-item" to={op.nombre === "aguablancahac" ? "/" : "/inicio"}>
          <a className="nav-link text-light botons rounded-pill fw-bold">
            <i className="fas fa-door-open p-1" />
            Salir
          </a>
        </Link>
      </ul>

      <VerConfiguracion
        show={mostrar}
        onHideCancela={() => {
          setMostrar(false);
        }}
      />
      <CambioClave
        show={mostrarClave}
        onHideCancelar={() => {
          setMostrarClave(false);
        }}
        render={() => {
          setMostrarClave(false);
        }}
      />
      <Dimmer active={activate} inverted />
    </nav>
  );

  return header;
}

export default Header;
